import breastPath from "./pathwayQuestions/breastPath";
import cnsPath from "./pathwayQuestions/cnspath";
import colorectalPath from "./pathwayQuestions/colorectalpath";


const pathwayQuestionIndex=
    {
    colorectalPath:colorectalPath,
    cnsPath:cnsPath,
    breastPath:breastPath

    }


export default pathwayQuestionIndex